import { render, staticRenderFns } from "./SupplierAgingSummaryBarChart.vue?vue&type=template&id=cc5d1c66"
import script from "./SupplierAgingSummaryBarChart.vue?vue&type=script&lang=ts"
export * from "./SupplierAgingSummaryBarChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports